module.exports = __webpack_public_path__ + "media/images/iconSocialFacebook__accent--dark-77265f17ff8b7426fdd7c8c998139154.png";